// import { faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
// import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
// import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
// import { faAngellist } from '@fortawesome/free-brands-svg-icons/faAngellist';
// import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/alexkashi',
    label: 'Github',
    icon: faGithub,
  },
  // {
  //   link: 'https://www.instagram.com/alexkashi/',
  //   label: 'Instagram',
  //   icon: faInstagram,
  // },
  {
    link: 'https://www.linkedin.com/in/alexkashi',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  // {
  //   link: 'https://twitter.com/itsalexkashi',
  //   label: 'Twitter',
  //   icon: faTwitter,
  // },
  // {
  //   link: 'https://tiktok.com/@itsalexkashi',
  //   label: 'Tiktok',
  //   icon: faTiktok,
  // },
  {
    link: 'mailto:akashi@berkeley.edu',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
